import { useState, useCallback, useEffect } from 'react'
import { navSetUrl } from '../globals.js'
import { CURRENT_USER } from '../globals.js'

const BDR_PAGES = new Set(['followup', 'directory', 'client', 'accounts', 'contacts', 'campaigns', 'proposals'])

function getInitialPage() {
  const isBDR = CURRENT_USER?.role === 'bdr'
  const urlV = new URLSearchParams(window.location.search).get('v')
  const saved = urlV || localStorage.getItem('oike_page') || 'followup'
  if (isBDR && !BDR_PAGES.has(saved)) return 'followup'
  return saved
}

export function useNavigation() {
  const [page, setPage] = useState(getInitialPage)
  const [navigateToAccountId, setNavigateToAccountId] = useState('')
  const [navigateToSolId, setNavigateToSolId] = useState('')
  const [navigateToEventId, setNavigateToEventId] = useState('')
  const [navigateToProposalId, setNavigateToProposalId] = useState('')
  const [navigateToAccountTab, setNavigateToAccountTab] = useState('')
  const [campaignPrefill, setCampaignPrefill] = useState(null)
  const [navigateToStakeholderId, setNavigateToStakeholderId] = useState('')

  const setPageAndSave = useCallback((p) => {
    setPage(p)
    localStorage.setItem('oike_page', p)
    navSetUrl(p, null)
  }, [])

  const goToAccount = useCallback((accountId) => {
    setNavigateToAccountId(accountId)
    setPageAndSave('accounts')
  }, [setPageAndSave])

  const goToMessageLab = useCallback((stakeholderId) => {
    setNavigateToStakeholderId(stakeholderId)
    setPageAndSave('messagelab')
  }, [setPageAndSave, setNavigateToStakeholderId])

  const goToSolution = useCallback((solId) => {
    setNavigateToSolId(solId)
    setPageAndSave('solutionshub')
  }, [setPageAndSave])

  const goToProposal = useCallback((proposalId) => {
    if (proposalId) setNavigateToProposalId(proposalId)
    setPageAndSave('proposals')
  }, [setPageAndSave])

  const createCampaignFromInsight = useCallback((prefill) => {
    setCampaignPrefill(prefill)
    setPageAndSave('campaigns')
  }, [setPageAndSave])

  // Listen to global navigation events
  useEffect(() => {
    const handler = (e) => {
      if (e.detail?.page) {
        setPageAndSave(e.detail.page)
        if (e.detail.accountId) setNavigateToAccountId(e.detail.accountId)
        if (e.detail.tab) setNavigateToAccountTab(e.detail.tab)
        if (e.detail.stakeholderId) setNavigateToStakeholderId(e.detail.stakeholderId)
      }
    }
    window.addEventListener('oike:navigate', handler)
    return () => window.removeEventListener('oike:navigate', handler)
  }, [setPageAndSave])

  // Handle browser back/forward
  useEffect(() => {
    const onPopState = (e) => {
      const params = new URLSearchParams(window.location.search)
      const p = e.state?.page || params.get('v') || localStorage.getItem('oike_page') || 'followup'
      setPage(p)
      localStorage.setItem('oike_page', p)
    }
    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
  }, [])

  return {
    page,
    setPageAndSave,
    goToAccount,
    goToSolution,
    goToProposal,
    goToMessageLab,
    createCampaignFromInsight,
    navigateToAccountId, setNavigateToAccountId,
    navigateToStakeholderId, setNavigateToStakeholderId,
    navigateToSolId, setNavigateToSolId,
    navigateToEventId, setNavigateToEventId,
    navigateToProposalId, setNavigateToProposalId,
    navigateToAccountTab, setNavigateToAccountTab,
    campaignPrefill, setCampaignPrefill,
  }
}
